import styled from 'styled-components'

const SurveyQuestionUi = styled.div``

export default SurveyQuestionUi
